/**
 * @module components\subroute\About
 */
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class About extends Vue {
  dialog = false;
  openImage() {
    this.dialog = true;
  }
  closeImage() {
    this.dialog = false;
  }
}
